import React from 'react'
import AuthLayout from '../../../components/auth/auth-layout'
import SignIn from './sign-in'

const B2CSignIn = ({ tenant }) => {
  return (
    <AuthLayout>
      <SignIn />
    </AuthLayout>
  )
}

export default B2CSignIn
